import React from "react";
import { BaseIcon, BaseIconProps, BaseSVGIconProps } from "./BaseIcon";

const SvgCreateReportIcon = ({
  color,
  alt,
  "aria-roledescription":
    roleDescription = "Presentation screen with a plus in the center",
  ...restProps
}: BaseSVGIconProps) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...restProps}
  >
    <title>{alt}</title>
    {roleDescription ? <desc>{roleDescription}</desc> : null}
    <g clipPath="url(#clip0_24662_258337)">
      <path
        d="M16.875 3.75H3.125C2.77982 3.75 2.5 4.02982 2.5 4.375V13.75C2.5 14.0952 2.77982 14.375 3.125 14.375H16.875C17.2202 14.375 17.5 14.0952 17.5 13.75V4.375C17.5 4.02982 17.2202 3.75 16.875 3.75Z"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.5 14.375L15 17.5"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.5 14.375L5 17.5"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 3.75V1.875"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <g clipPath="url(#clip1_24662_258337)">
        <path
          d="M7.42188 9.25H12.5781"
          stroke={color}
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10 6.67188V11.8281"
          stroke={color}
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_24662_258337">
        <rect
          width="20"
          height="20"
          fill="white"
        />
      </clipPath>
      <clipPath id="clip1_24662_258337">
        <rect
          width="7.5"
          height="7.5"
          fill="white"
          transform="translate(6.25 5.5)"
        />
      </clipPath>
    </defs>
  </svg>
);

const CreateReportIcon = (props: BaseIconProps) => (
  <BaseIcon {...props}>
    <SvgCreateReportIcon />
  </BaseIcon>
);

export default CreateReportIcon;
